<template>
  <div id="re_list">
    <van-nav-bar
      title="报销单列表"
      left-text="返回"
      left-arrow
      right-text="创建报销"
      @click-left="onClickLeft"
      @click-right="createReim"
    />
    <div style="position: relative;overflow: hidden;">
      <van-dropdown-menu>
        <van-dropdown-item v-model="queryForm.brand_id" :options="brands" @change="changeBrand" />
        <van-dropdown-item v-model="queryForm.city_id" :options="cities" @change="changeCity" />
        <div style="position: absolute; right: 20px; top: 10px; width: 80px;" @click="showSearch">
          <van-icon name="filter-o"  />操作
        </div>
      </van-dropdown-menu>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="loading_list loading_list_item" @click="showDetail(item)">
        <div class="loading_list_header">
          <div class="loading_list_code">{{ item.reim_no }} </div>
          <div class="loading_list_bottom_text">{{ item.create_at }}</div>
        </div>
        <div class="loading_list_content">
            <div class="loading_list_brand">品牌: {{ item.brand_en }} </div>
            <div class="loading_list_city">城市: {{ item.city_cn }} </div>
            <div class="loading_list_market">商场: {{ item.market_cn }}</div>
            <div class="loading_list_shop">店铺: {{ item.store_cn }}</div>
        </div>
        <div class="loading_list_bottom">
          <div class="loading_list_job_type">工作类型: {{ item.a_cate_cn }} </div>
          <div class="loading_list_status">
            <div v-if="item.pre_quote_status == 1" style="background-color: green; color: #FFFFFF; width: 20px; height: 20px; text-align: center; line-height: 20px; border-radius: 2px; float: left;">
              预
            </div>
            <van-tag :type="color_tag_types[item.reim_status_color]" v-if="item.reim_status_value">{{ item.reim_status_value }}</van-tag>
          </div>
        </div>
      </div>
    </van-list>
    <van-popup v-model:show="show" position="right" :style="{ width: '70%', height: '100%' }">
      <div style="text-align: left;padding: 20px;">操作</div>
      <el-form label-position="left" label-width="60px" style="width: 94%; margin: 10px auto;">
        <el-form-item label="商场：" prop="market_id">
          <el-select v-model="queryForm.market_id" :allow-create="true" placeholder="支持输入" filterable class="form-item-width" @change="syncShops">
            <el-option v-for="(v, k) in marketList" :key="k" :value="v.id" :label="v.market_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺：" prop="store_id">
          <el-select v-model="queryForm.store_id" placeholder="请选择" filterable class="form-item-width">
            <el-option v-for="v in storeList" :key="v.id" :value="v.id" :label="v.name_cn" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否预报价：" v-if="!subordinate_worker" prop="store_id">
          <el-select v-model="queryForm.pre_quote_status" class="order-list-search-item" filterable clearable collapse-tags popper-class="select-all" style="width: 180px">
            <el-option v-for="(v, k) in preQuoteStatusList " :key="k" :value="k" :label="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="搜索：" prop="ma_remark">
          <el-input v-model="queryForm.ma_remark" placeholder="搜索" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>
    </van-popup>
  </div>
</template>

<script>
import {getReimExcelList, getRemiList} from "../../api/reimbursement";
import {getBrandList, getCityList, getMarketList, getShopList} from "../../api/order";
import {uploadWithoutOssToken} from "../../api/util";
import OSS from "ali-oss";
import {downloadFile} from "../../utils/download";
import {getBaseInfo} from "../../api/user";

const STATUS = ['', '待接受', '已提交', '待维修', '已完工', '待验收', '验收通过', '待返工']
const REPAIR_TYPES = ['定期维保', '紧急维修', '改造工程']

const COLOR_TAG_TYPES = {
  yellow: 'warning',
  red: 'danger',
  green: 'success',
  blue: 'primary'
}

export default {
  name: 'reimbursement_list',
  data () {
    return {
      value2: '',
      active: 0,
      shops: [],
      cities: [],
      markets: [],
      brands: [],
      storeList: [],
      marketList: [],
      preQuoteStatusList: {
        'all': '全部',
        '0': '否',
        '1': '是'
      },
      queryForm: {
        create_date: [],
        select_date: [],
        states: [],
        brandIds: [],
        applyDate: [],
        completeDate: [],
        code: '',
        city_id: '',
        market_id: '',
        brand_id: '',
        pre_quote_status: 'all'
      },
      statusOptions: [],
      option2: [],
      finished: false,
      loading: false,
      loadingStatus: false,
      list: [],
      page: 1,
      pageSize: 20,
      color_tag_types: COLOR_TAG_TYPES,
      show: false,
      subordinate_worker: false,
    }
  },
  created () {
    if (this.$store.getters.info && typeof this.$store.getters.info.subordinate_worker !== 'undefined') {
      this.subordinate_worker = this.$store.getters.info.subordinate_worker
    }
    this.getBrandList()
    this.getCityList()
  },
  methods: {
    onSubmit() {
      this.show = false
      this.queryList()
    },
    syncShops() {
      this.searchStore()
    },
    async exportExcel() {
      this.loading = true
      const search = this.queryForm
      if (typeof this.queryForm.select_date !== 'undefined' && this.queryForm.select_date.length > 0) {
        search.completed_start_at = this.queryForm.select_date[0]
        search.completed_end_at = this.queryForm.select_date[1]
      }
      if (this.queryForm.create_date.length > 0) {
        search.reim_create_start_at = this.queryForm.create_date[0]
        search.reim_create_end_at = this.queryForm.create_date[1]
      }
      await getReimExcelList(search).then((result) => {
        console.log("res..........", result.data.data.list)
        if (result.data.data && result.data.data.filename) {
          uploadWithoutOssToken({ file_suffix: 'xlsx', only_download: 1 }).then(
            (res) => {
              const ossData = res.data.data
              const client = new OSS({
                region: 'oss-' + ossData.region_id,
                accessKeySecret: ossData.access_secret,
                accessKeyId: ossData.access_id,
                stsToken: ossData.secret_token,
                bucket: ossData.bucket
              })
              const filename = '报销单明细.xlsx'
              const response = {
                'content-disposition': `attachment; filename=${encodeURIComponent(
                  filename
                )}`
              }
              const url = client.signatureUrl(result.data.data.filename, {
                response
              })
              downloadFile(url, filename)
              this.exportLoading = false
            }
          )
        }
      })
    },
    showSearch() {
      this.show = true
      this.getBrandList()
      this.marketLists(this.queryForm.city_id)
      this.searchStore()
    },
    changeCity(val) {
      this.searchStore()
      this.queryList()
    },
    queryList() {
      this.page = 1
      this.list = []
      this.initList()
    },
    async changeBrand(val) {
      this.searchStore()
      await this.queryList()
    },
    changeMarket(val) {
      this.searchStore()
    },
    getBrandList() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brands = [{
            text: '所有品牌',
            value: ''
          }]
          for (const i in res.data.data) {
            this.brands.push({
              text: res.data.data[i].brand_en,
              value: res.data.data[i].id
            })
          }
        }
        console.log('brands.......', this.brands)
      })
    },
    getCityList() {
      getCityList().then((res) => {
        if (res.data.data) {
          this.cities = [{
            text: '所有城市',
            value: ''
          }]
          for (const i in res.data.data) {
            this.cities.push({
              text: res.data.data[i].city_cn,
              value: res.data.data[i].id
            })
          }
        }
        console.log('iiiiiii', this.cities)
      })
    },
    marketLists(cityId) {
      getMarketList({city_id: cityId}).then((res) => {
        if (res.data.data) {
          this.marketList = res.data.data
        }
      })
    },
    searchStore() {
      console.log('queryForm..........', this.queryForm)
      getShopList(this.queryForm).then((res) => {
        if (res.data.data) {
          this.storeList = res.data.data
        }
      })
    },
    createReim() {
      this.$router.push({ path: '/order_reimbursement', query: { pre_quote_status: this.preQuoteStatus, subordinate_worker: this.subordinate_worker } })
    },
    async initList () {
      if (this.loadingStatus) {
        return false
      }
      let queryData = {page: this.page, page_size: this.pageSize, pre_quote_status: this.queryForm.pre_quote_status}
      if (this.queryForm.city_id) {
        queryData.city_id = this.queryForm.city_id
      }
      if (this.queryForm.brand_id) {
        queryData.brand_id = this.queryForm.brand_id
      }
      console.log('query.....data.....', queryData)
      this.loadingStatus = true
      await getRemiList(queryData).then((res) => {
        if (res.data.data.list) {
          const data = res.data.data.list
          if (data.length < this.pageSize) {
            this.finished = true
          }
          for (const item in res.data.data.list) {
            this.list.push(res.data.data.list[item])
          }
          this.loadingStatus = false
          this.page++
        } else {
          this.finished = true
          this.loadingStatus = false
          this.list = []
        }
      })
    },
    onLoad () {
      setTimeout(() => {
        if (this.loadingStatus) {
          return false
        }
        if (this.finished) {
          return false
        }
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }
        this.initList()
        this.loading = false
      }, 1000)
    },
    onRefresh () {
      if (this.finished) {
        return false
      }
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
      /*if (this.$route.query.appo_task_id && this.$route.query.ma_item_id) {
        this.$router.push({path: '/warranty_detail', query: {ma_item_id: this.$route.query.ma_item_id, appo_task_id: this.$route.query.appo_task_id}})
      } else {
        this.$router.push({path: '/index'})
      }*/
    },
    showReport (id, val) {
      this.$router.push({path:'/warranty_detail', query: {id: id, annex_id: val.annex_id}})
    },
    changeTypes (index) {
      this.active = index
      let status = ''
      if (index === 0) {
        status = ''
      } else if (index === 1) {
        status = 0
      } else if (index === 2) {
        status = 1
      } else if (index === 3) {
        status = 2
      }
      // 0已提交、1审批通过、2拒绝、3保存
      this.initList(1, status)
      this.list = []
    },
    changeStatus (val) {
      this.checkStatus = val
      this.list = []
      this.finished = false
      this.page = 1
      this.initList(val, this.value2)
    },
    changeSort (val) {
      this.value2 = val
      this.list = []
      this.page = 1
      this.initList(this.checkStatus, val)
    },
    checkStatus() {

    },
    showDetail(item) {
      this.$router.push({path: '/order_reimbursement', query: {appo_task_id: item.appo_task_id, reim_id: item.reim_id}})
    }
  }
}
</script>

<style>
#re_list .van-card__content {
  text-align: left;
}
#re_list .van-dropdown-menu__bar {
  width: 70% !important;
  padding-right: 40% !important;
}
.el-select-dropdown {
  z-index: 9999 !important;
}
</style>

<style scoped>

#re_list {
  background: #F5F5F5;
}
.loading_list {
  background-color: #fff;
  margin: 10px 5px;
  border-radius: 4px;
}
.loading_list_item {
  width: 96%;
  margin: 5px auto;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 10px;
}
.loading_list_header { overflow: hidden; padding-top: 10px; padding-right: 2%; }
.loading_list_code { float: left; color: #000000; font-weight: 500; width: 60%; font-size: 16px; text-align: left;padding-left: 5%; }
.loading_list_status { float: right !important; text-align: right; width: 30%; font-size: 14px; height: 16px; }
.loading_list_content { overflow: hidden; text-align: left; padding-left: 5%; margin: 6px auto; font-size: 14px; color: #717989;}
.loading_list_content_left { float: left; width: 40%; padding-left: 5%; text-align: left; }
.loading_list_content_right { float: right; text-align: left; width: 50%; }
.loading_list_bottom_text {
  font-size: 12px; text-align: right;
  height: 15px;
  float: right;
  width: 35%;
}
.loading_list_job_type {
  font-size: 14px;
  color: #717989;
}
.loading_list_bottom {
  padding: 0 5% 10px;
}
.loading_list_bottom div {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/order/reimbursement_list.vue